module.exports = __webpack_public_path__ + "static/618c8a29024d0b28b597d5ad71ea2b0110a52258d6e121a3cc58db981b0c4c57-edd6e8037d3aec7f50a4dfb2d1163534.jpeg";